import {
  MrSearchConfig,
  MrSearchFacetsConfig,
  MrSearchLayoutInput,
} from '@net7/boilerplate-muruca';

const facets = {
  sections: [
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_query',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-author',
      header: {
        id: 'header-author',
        data: {
          text: 'search#header_authors',
          additionalText: null
        }
      },
      inputs: [
        {
          type: 'text',
          id: 'query-author',
          target: 'author',
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-authors',
            placeholder: 'search#placeholder_authors',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
        {
          id: 'author',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true
          },
          data: {
            links: []
          }
        }
    ]
    },
    // {
    //   id: 'section-author_alias',
    //   header: {
    //     id: 'header-author_alias',
    //     data: {
    //       text: 'search#header_author_alias',
    //       additionalText: null
    //     }
    //   },
    //   inputs: [
    //     {
    //       type: 'text',
    //       id: 'query-author_alias',
    //       target: 'author_alias',
    //       delay: 500,
    //       schema: {
    //         valueType: 'string',
    //       },
    //       data: {
    //         id: 'query-author_alias',
    //         placeholder: 'search#placeholder_author_alias',
    //         icon: 'n7-icon-search',
    //         inputPayload: 'search-input',
    //         enterPayload: 'search-enter',
    //         iconPayload: 'search-icon',
    //       },
    //     },
    //     {
    //       id: 'author_alias',
    //       type: 'link',
    //       limit: 50,
    //       queryParam: true,
    //       schema: {
    //         valueType: 'string',
    //         multiple: true
    //       },
    //       data: {
    //         links: []
    //       }
    //     }
    //   ]
    // },
    {
      id: 'section-genre',
      header: {
        id: 'header-genre',
        data: {
          text: 'search#header_genre',
          additionalText: null
        }
      },
      inputs: [{
        id: 'genre',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-century',
      header: {
        id: 'header-century',
        data: {
          text: 'search#header_century',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'century',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-metric',
      header: {
        id: 'header-metric',
        data: {
          text: 'search#header_metric',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'metric',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    // {
    //   id: 'section-id',
    //   header: {
    //     id: 'header-id',
    //     data: {
    //       text: 'search#header_id',
    //       additionalText: null
    //     }
    //   },
    //   inputs: [
    //     {
    //       id: 'id',
    //       type: 'link',
    //       limit: 50,
    //       queryParam: true,
    //       schema: {
    //         valueType: 'string',
    //         multiple: true
    //       },
    //       data: {
    //         links: []
    //       }
    //     }
    //   ]
    // },
  ],
  classes: 'facets-wrapper',
} as MrSearchFacetsConfig;

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
})) as MrSearchLayoutInput[];

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
